"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const EventPickerFloatingMenu_1 = __importDefault(require("./EventPickerFloatingMenu"));
const Typeahead_1 = require("./Typeahead");
const filterItems_1 = __importDefault(require("./filterItems"));
const react_1 = require("react");
function inertGetLabelForItem(item) {
    return item.label;
}
function EventPicker({ groups, initialValue, onSelect }) {
    const renderFloatingMenu = react_1.useCallback(({ items, getItemProps, selectedItem }) => (common_utils_1.isolateComponent(EventPickerFloatingMenu_1.default, { getItemProps: getItemProps, groups: items, selectedItem: selectedItem })), []);
    const onChange = react_1.useCallback((selectedItem, eventLocation) => {
        if (selectedItem) {
            onSelect(selectedItem, eventLocation);
        }
    }, [onSelect]);
    return (common_utils_1.isolateComponent(Typeahead_1.Typeahead, { autoComplete: "off", filterItems: filterItems_1.default, getLabelForItem: inertGetLabelForItem, iconEndName: "arrowDropdown", initialSelectedItem: initialValue, items: groups, keepInputValueOnBlur: false, menuAriaLabel: "Search and select an event", onChange: onChange, openOnFocus: true, placeholder: "Choose an event", renderFloatingMenu: renderFloatingMenu }));
}
exports.default = EventPicker;
